// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"QuoteBox_bgColor__3tRGX","btnsContainer":"QuoteBox_btnsContainer__3TK3X"};